import { render, staticRenderFns } from "./Dispatchers-st-ts.component.vue?vue&type=template&id=e6bb9722"
import script from "./Dispatchers-st-ts.component.vue?vue&type=script&lang=js"
export * from "./Dispatchers-st-ts.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports